var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.error)?_c('ActivationError',{attrs:{"error":_vm.error}}):(_vm.activationStatus === null)?_c('ActivationInProgress'):(_vm.activationStatus === true )?_c('ActivationSuccessful'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }